module.exports = __webpack_public_path__ + "img/nicola-icon.58d9987e.jpg";